import React from 'react';
import { Row, Col } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import Issues from './Issues';
import { AddsContainer } from './common';

function IssuesContainer({
  itemKey,
  item,
  services,
  addSubItem,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  return (
    <Row style={{ margin: '10px' }} gutter={16}>
      <Col span={24}>
        <AddsContainer>
          <Row type="flex" align="middle">
            <Col style={{ width: 40, textAlign: 'center' }}>
              <WarningOutlined style={{ fontSize: '32px' }} />
            </Col>
            <Col style={{ flex: 1, paddingLeft: 5 }}>
              <Row>
                <Col span={23} style={{ borderBottom: '1px solid #d9d9d9' }}>
                  Issues
                </Col>
                <Col span={1}></Col>
              </Row>
              <Issues
                services={services}
                itemKey={itemKey}
                item={item}
                deleteSubItem={() => deleteSubItem(itemKey, 'services')}
                changeItemProperty={changeItemProperty}
              />
            </Col>
          </Row>
        </AddsContainer>
      </Col>
    </Row>
  );
}

export default IssuesContainer;
